import React from 'react';
import { Helmet } from 'react-helmet-async';
import { hasSeoMeta, SeoMeta } from './seo.utils';

type Props = {
  category?: string;
  meta?: SeoMeta | null;
  canonicalUrl?: string;
};

export const SeoHelmet: React.FC<Props> = ({ category, meta, canonicalUrl }) => {
  if (!hasSeoMeta(meta)) return null;

  return (
    <Helmet key={category ? `seo-${category}` : undefined}>
      {meta?.title && <title>{meta.title}</title>}
      {meta?.description && <meta name="description" content={meta.description} />}
      {meta?.keywords && <meta name="keywords" content={meta.keywords} />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
    </Helmet>
  );
};
